import { render, staticRenderFns } from "./OrderNew.vue?vue&type=template&id=2d9e064d&"
import script from "./OrderNew.vue?vue&type=script&lang=ts&"
export * from "./OrderNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports